import {
  Component,
  inject,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import {
  BolseiroService,
  InstituicaoEnsinoService,
  CommunicationService,
  PaisService,
  ProvinciaService,
  MunicipioService,
  UtilizadorService,
  EnumService,
  TipoInstituicaoEnsinoService,
} from '@app/features-modules/gestao-bolseiros/components/api/services';
import { ApiService } from '@core/providers/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService, MenuItem } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import {
  TableComponent,
} from '@app/shared/components/table/table.component';
import { Pagination } from '@app/shared/model';
import { CardEmpresaComponent } from '@app/shared/components/card-empresa/card-empresa.component';
import {
  FilterItem,
} from '@app/features-modules/gestao-bolseiros/components/api/models';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { RouterLink } from '@angular/router';
import { SelectModule } from 'primeng/select';
import { DialogModule } from 'primeng/dialog';
import { InputText } from 'primeng/inputtext';
import { Button } from 'primeng/button';
import { Subscription, forkJoin } from 'rxjs';
import { CadastroIntituicaoEnsinoComponent } from '@app/features-modules/gestao-bolseiros/components/instituicoes-ensino/cadastro-intituicao-ensino/cadastro-intituicao-ensino.component';
@Component({
  selector: 'app-listar-instituicao-de-ensino',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SearchBarComponent,
    DialogModule,
    SelectModule,
    ToastModule,
    Button,
    ConfirmDialogModule,
    InputText,
    TableComponent,
    DataVoidComponent,
    CardEmpresaComponent,
    ToastModule,
    PaginatorControlComponent
  ],
  providers: [
    DialogService,
    ApiService,
    BolseiroService,
    InstituicaoEnsinoService,
    MessageService,
    ConfirmationService,
    CommunicationService,
    UtilizadorService,
  ],
  templateUrl: './listar-instituicao-de-ensino.component.html',
  styleUrl: './listar-instituicao-de-ensino.component.scss',
  standalone: true,
})
export class ListarInstituicaoDeEnsinoComponent implements OnInit, OnDestroy {
  @Input() perfilEmpresaGestora: any;
  dialogService = inject(DialogService);
  private router = inject(Router);
  confirmationService = inject(ConfirmationService);
  messageService = inject(MessageService);
  bolseiroService = inject(BolseiroService);
  instituicaoEnsinoService = inject(InstituicaoEnsinoService);
  communicationService = inject(CommunicationService);
  paisService = inject(PaisService);
  provinciaService = inject(ProvinciaService);
  municipioService = inject(MunicipioService);
  utilizadorService = inject(UtilizadorService);
  tipoInstituicaoEnsinoService = inject(TipoInstituicaoEnsinoService);
  isLoading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 120;
  pagination: Pagination<any> = new Pagination<any>();
  countries: any[] = [];
  provinces: any[] = [];
  municipalities: any[] = [];
  form!:FormGroup;
  private enumService = inject(EnumService);
  route = inject(ActivatedRoute);
  private subscriptions = new Subscription();
  filters: FilterItem[] = [
    { type: 'text', controlName: 'nome', placeholder: 'Pesquise pelo nome' },
    { type: 'text', controlName: 'Sigla', placeholder: 'Pesquise pela sigla' },
  ];
  imagePreviewMap: { [id: number]: string | ArrayBuffer | null } = {}; // To store image as Base64 URL
  typeofEducationalInstitution: any[] = [];
  naturezaOptions: any[] = [];
  constructor() {
    this.loadCountries();
  }

  ngOnInit() {
    this.loadEnums();
    this.subscriptions.add(
      this.communicationService.countryChanged$.subscribe(
        (country: string | null) => {
          if (country) {
            this.loadProvinces(country);
          }
        }
      )
    );

    this.subscriptions.add(
      this.communicationService.provinceChanged$.subscribe(
        (province: string | null) => {
          if (province) {
            this.loadMunicipalities(province);
          }
        }
      )
    );

    this.getAllInstituicoesEnsino();

  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  loadEnums() {
    forkJoin({
      naturezaInstituicao: this.enumService.getAllNaturezaInstituicaoEnum(),
      tipoInstituicao: this.enumService.getAllTipoInstituicaoEnum(),
    }).subscribe((response: any) => {
      if (response.naturezaInstituicao?.data) {
        this.naturezaOptions = Object.entries(
          response.naturezaInstituicao.data
        ).map(([key, value]) => ({
          id: Number(key),
          designacao: value,
        }));
      }

      if (response.tipoInstituicao?.data) {
        this.typeofEducationalInstitution = Object.entries(
          response.tipoInstituicao.data
        ).map(([key, value]) => ({
          id: Number(key),
          designacao: value,
        }));
      }
    });
  }

  loadCountries() {
    this.paisService.list().subscribe((countries) => {
      this.countries = countries;
    });
  }

  loadProvinces(country: string) {
    this.provinciaService.list(country).subscribe((provinces) => {
      this.provinces = provinces;
      this.communicationService.updateProvinces(provinces);
      this.municipalities = []; // Reset municipalities when country changes
    });
  }

  loadMunicipalities(province: string) {
    this.municipioService.list(province).subscribe((municipalities) => {
      this.municipalities = municipalities;
      this.communicationService.updateMunicipalities(municipalities);
    });
  }

  showDialog() {
    const ref = this.dialogService.open(CadastroIntituicaoEnsinoComponent, {
      showHeader: false,
      width: '45%',
      modal: true,
      data: {
        countries: this.countries,
        provinces: this.provinces,
        municipalities: this.municipalities,
        typeofEducationalInstitution: this.typeofEducationalInstitution,
        naturezaOptions: this.naturezaOptions,
        isEditMode: false,
      },
    });

    ref.onClose.subscribe((data) => {
      if (data instanceof FormData) {
        this.isLoading = true;

        this.instituicaoEnsinoService.store(data).subscribe({
          next: (response: any) => {
            this.isLoading = false;
            if (response.retorno?.codigo === 200) {
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: 'Instituição de Ensino registada com sucesso!',
                life: 3000,
              });
              this.getAllInstituicoesEnsino();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Erro',
                detail:
                  response.retorno?.mensagem ||
                  'Erro ao criar instituição de ensino.',
                life: 3000,
              });
            }
          },
          error: (error: any) => {
            this.isLoading = false;
            console.error('Erro ao criar instituição de ensino:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail:
                error.error?.retorno?.mensagem ||
                'Erro ao criar instituição de ensino.',
              life: 3000,
            });
          },
        });
      }
    });
  }

  getAllInstituicoesEnsino(queryParams: any = {}): void {
    this.isLoading = true;
    console.log('Carregando instituições de ensino com parâmetros:', this.perfilEmpresaGestora);
    const params = {
      ...queryParams,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      PaisID: this.perfilEmpresaGestora?.paisID || null,
      OrderBy: queryParams?.OrderBy || 'id desc',
    };

    this.instituicaoEnsinoService.list(params).subscribe({
      next: (response: any) => {
        this.pagination = new Pagination<any>().deserialize(response);
        this.isLoading = false;

        // Inicia o carregamento das imagens sem travar o fluxo principal
        this.pagination?.data?.forEach((inst) => {
          this.loadImagemInstituicao(inst.id);
        });
      },
      error: (error) => {
        console.error('Erro ao carregar instituições de ensino:', error);
        this.isLoading = false;
      },
    });
  }

  loadImagemInstituicao(id: number): void {
    this.instituicaoEnsinoService.getFotoInstituicaoById(id).subscribe({
      next: (response: Blob) => {
        if (!response || !response.type.startsWith('image/')) {
        console.warn('Resposta não é imagem. A usar placeholder.');
        this.imagePreviewMap[id] = null;
        return;
      }
        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreviewMap[id] = reader.result as string;
        };
        reader.onerror = () => {
          this.imagePreviewMap[id] = null;
        };
        reader.readAsDataURL(response);
      },
      error: (err) => {
        console.error(`Erro ao carregar imagem da instituição ${id}:`, err);
        this.imagePreviewMap[id] = null;
      },
    });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getAllInstituicoesEnsino();
  }

  trackById(index: number, item: any) {
    return item.id ?? index;
  }

  showFilter = false;

  showFilterModal() {
    this.showFilter = true;
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== ''
      )
    );
    this.getAllInstituicoesEnsino(filters);
    this.showFilter = false;
  }
}
